export const iconFontAwesomeToggleWifi = (
	<i className="fa-solid fa-wifi"></i>
);
